import { DatePickerProps, DatePicker } from "@material-ui/pickers";
import lodash from "lodash";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

interface Props extends Omit<DatePickerProps, "value" | "onChange"> {
  name: string;
  label?: string;
}

const FormDatePicker: React.FC<Props> = (props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { name, label, ...rest } = props;
  const error = lodash.get(errors, name);
  const hasError = !!error;
  const errorText = !!error ? error.message : "";

  return (
    <Controller
      render={({ field: { onBlur, onChange, value } }) => {
        return (
          <DatePicker
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            label={label}
            error={!!hasError}
            helperText={errorText}
            animateYearScrolling
            inputVariant="outlined"
            variant="dialog"
            format="dd.MM.yyyy"
            margin="normal"
            id="form-date-picker"
            {...rest}
          />
        );
      }}
      control={control}
      name={name}
    />
  );
};

export default FormDatePicker;
